import React from 'react';
import { FormError, HelpText } from '@Forms/fields.jsx';

const TextAreaField = ({
  error,
  helpText,
  label,
  name,
  placeholder = '',
  register,
  options = {},
  type = 'text',
  rows = 4,
  ...props
}) => {
  // resuable text field
  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-input ` +
        (error ? 'sb-form-item-error' : '')
      }
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className="sb-form-item-content">
        <textarea
          aria-invalid={error ? 'true' : 'false'}
          rows={rows}
          {...register(name, options)}
          {...props}
        />
        {helpText && <HelpText message={helpText} />}
        {error && <FormError message={error.message} />}
      </div>
    </div>
  );
};

export default TextAreaField;
